// @flow
import type { AppState } from 'stores'
import MotionPopup from 'components/popup/component'
import { connect } from 'react-redux'
import { branch, renderNothing } from 'recompose'
import { compose } from 'redux'
import { mapActiveMunicipality } from '../map/reducer'

const mapStateToProps = ({ popup, interactionCapabilities }: AppState) => {
  return {
    ...popup,
    useTouch: interactionCapabilities.touch
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onCloseHandler: (event: SyntheticEvent<HTMLAnchorElement>) => {
      event.stopPropagation()
      dispatch(mapActiveMunicipality(-1))
    }
  }
}

const renderNothingIfWrongActiveMunicipality = branch(
  ({ visible }) => !visible,
  renderNothing
)

const enhanceComponent = compose(
  connect(mapStateToProps, mapDispatchToProps),
  renderNothingIfWrongActiveMunicipality
)

export default enhanceComponent(MotionPopup)
